import React from 'react';
import HeroSection from './HeroSection';
import ProjectsSection from './ProjectsSection';
import ExperienceSection from './ExperienceSection';
import ToolsSection from './ToolsSection';
import ContactSection from './ContactSection';

const RightContent = () => {
  return (
    <main className="right-content">
      <HeroSection />
      <ToolsSection />
      <ProjectsSection />
      <ExperienceSection />
      <ContactSection />

      <style jsx>{`
        .right-content {
          flex: 1;
          padding: 24px;
          padding-left: 40px;
          margin-left: 380px;
          max-width: calc(100% - 380px);
        }

        @media (max-width: 1024px) {
          .right-content {
            padding: 20px 16px;
            max-width: 100vw;
            margin-left: 0;
          }
        }

        @media (max-width: 480px) {
          .right-content {
            padding: 16px 12px;
          }
        }
      `}</style>
    </main>
  );
};

export default RightContent;
